/**
 * StatusIndicatorBadges Component
 *
 * Displays status indicator badges showing count of diligences by status.
 * Each badge shows a colored background with the count number.
 * Colors come from CSS variables via the status-badges mixin.
 * Hover shows status label (À faire, Révisée, etc.) via Tooltip.
 *
 * @module vsme-shared/components/StatusIndicatorBadges
 */

import React, { memo } from 'react';
import { Tooltip } from '@tpct/admin-ui';
import type { StatusIndicator } from '../types/statusIndicator';
import { STATUS_LABELS } from './StatusBadge';

export type StatusIndicatorBadgesProps = {
  indicators: StatusIndicator[];
  className?: string;
};

/**
 * StatusIndicatorBadges Component
 * Renders colored badges for each status type with count
 * Uses CSS classes that get colors from CSS variables (single source of truth)
 */
const StatusIndicatorBadges = ({ indicators, className = '' }: StatusIndicatorBadgesProps) => {
  return (
    <div className={`vsme-status-indicator-badges ${className}`}>
      {indicators.map((indicator) => (
        <Tooltip key={indicator.status} text={STATUS_LABELS[indicator.status]} position="top">
          <span
            className={`vsme-status-indicator-badge vsme-status-indicator-badge--${indicator.status}`}
          >
            {indicator.count}
          </span>
        </Tooltip>
      ))}
    </div>
  );
};

export default memo(StatusIndicatorBadges);

